import service from '@api/config'

// 获取待办信息列表
export const todoList = (data) => {
  return service.request({
    url: `/index/todoList`,
    method: 'post',
    data: data
  })
}

// 删除待办信息
export const todoRemove = (data) => {
  return service.request({
    url: `/index/todoRemove`,
    method: 'post',
    data: data
  })
}

// 获取待办信息列表
export const todoTop = (data) => {
  return service.request({
    url: `/index/todoTop`,
    method: 'post',
    data: data
  })
}

// 删除待办信息
export const todoTopCancel = (data) => {
  return service.request({
    url: `/index/todoTopCancel`,
    method: 'post',
    data: data
  })
}

// 部分待办事项点击调用接口
export const todoHandle = (data) => {
  return service.request({
    url: `message/todoHandle`,
    method: 'post',
    data: data
  })
}

// ------------------------------推荐相关----------------------------

// 获取默认的筛选条件
export const getRecommendsInitParams = (data) => {
  return service.request({
    url: `/index/getRecommendsInitParams`,
    method: 'post',
    data: data
  })
}

// 筛选条件查询推荐信息列表，带分页
export const recommendsList = (data) => {
  return service.request({
    url: `/index/recommendsList`,
    method: 'post',
    data: data
  })
}

// 工种查询
export const getWorkList = (data) => {
  return service.request({
    url: `/typeOfWork/selectList`,
    method: 'post',
    data: data
  })
}

// 所有省以及热门城市查询
export const selectProvinceList = (data) => {
  return service.request({
    url: `/city/selectProvinceList`,
    method: 'post',
    data: data
  })
}

// 根据省查询所有市
export const selectCitiesByProvinceId = (data) => {
  return service.request({
    url: `/city/selectCitiesByProvinceId`,
    method: 'post',
    data: data
  })
}

// 移除推荐信息
export const removeRecommend = (data) => {
  return service.request({
    url: `/index/removeRecommend`,
    method: 'post',
    data: data
  })
}

// 获取发布时间用于筛选
export const getPubDay = (data) => {
  return service.request({
    url: `/search/pubDay`,
    method: 'post',
    data: data
  })
}

// 根据名称搜索省市
export const selectPCByName = (data) => {
  return service.request({
    url: `/city/selectPCByName`,
    method: 'post',
    data: data
  })
}

// 获取热门工种
export const typeOfWork = (data) => {
  return service.request({
    url: `/search/typeOfWork`,
    method: 'post',
    data: data
  })
}
